export default __webpack_public_path__ + "static/media/199.097205dc.jpg";